<template>
    <div>
        <b-btn variant="danger" :disabled="loading" class="font-weight-bold" block @click="OpenBox">
            Close Tab
        </b-btn>
    </div>
</template>

<script>
    import CashPay from "./cashPay";
    export default {
        name: "CloseTab",
        components: {CashPay},
        props: {
            order: {required: true},
            Total: {required: false},
            tabNo: {required: false},
            tableNo: {required: false},
            HasActiveReceiptPrinter: {required: false},
            HasActiveTicketPrinter: {required: false},
        },
        data () {
            return {
                loading: false
            }
        },
        methods: {
            setPrint () {
                this.modal = false
                this.$emit('getReceipt')
            },
            closeAll () {
                this.modal = false
                this.$emit('updateReport')
            },
            OpenBox () {
                const model = {
                    OrderId: this.order.OrderID,
                    // UserID: localStorage.getItem('userID'),
                    RestaurantID: this.$store.state.selectedRestaurantId,
                    PaymentStatusID:4
                }
                this.loading = true
                this.$api.getRestaurant.UpdateOrderCashPaid(model, true).then(res => {
                    this.loading = false
                    if (res.success) {
                        this.$emit('openCashBox')
                    } else {
                        this.$showError(res.message)
                    }
                })
            },
        }
    }
</script>

<style scoped>

</style>
